import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from 'atoms/Modal';

import StyledPauseMatchModal from './StyledPauseMatchModal';
import Button, { SecondaryButton } from 'styled/components/Button';

import { ModalProps } from 'atoms/Modal/ModalTypes';

import { modalsSlice } from 'features/modals/modalsSlice';
import { goToPenalties } from 'features/match/thunks';
import { useAppDispatch } from '../../../hooks/hooks';

const PenaltiesModal: React.FC<ModalProps> = (props) => {
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(modalsSlice.actions.setPenaltiesModal(false));
  };

  return (
    <Modal {...props}>
      <StyledPauseMatchModal>
        <div />
        <div className="text">
          <FormattedMessage id="modals.penalties" />
        </div>
        <div className="actions">
          <Button
            onClick={() => {
              dispatch(goToPenalties({}));
              close();
            }}
          >
            <FormattedMessage id="buttons.penalties" />
          </Button>
          <SecondaryButton whiteBackground greenText onClick={close}>
            <FormattedMessage id="buttons.cancel" />
          </SecondaryButton>
        </div>
      </StyledPauseMatchModal>
    </Modal>
  );
};

export default PenaltiesModal;
